import React from "react";
import styled from "styled-components";
import { theme } from "../../../../../../../helpers/theme";

interface RequiredInfoProps {
    text: string;
}

export const RequiredInfo = (props: RequiredInfoProps) => {
    const { text } = props;

    return (
        <Wraper>
            *{text}
        </Wraper>

    );
}

const Wraper = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight:  ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
colo;r: ${theme.colors.gray01_secondaryText};
`